import { Setting } from '../App';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export const useSubscriptionLine = (setting: Setting) => {
  const updateQuantity = (
    subscriptionContractId: string,
    lineId: string,
    quantity: number,
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=updateSubscriptionLine`,
          {
            subscriptionId: subscriptionContractId,
            lineId,
            quantity,
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  const removeProduct = (
    subscriptionContractId: string,
    lineId: string,
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=removeSubscriptionLine`,
          {
            subscriptionId: subscriptionContractId,
            subscriptionLine: {
              lineId: lineId,
            },
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  const addProduct = (
    planId: string,
    variantId: string,
    quantity: number,
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=addSubscriptionLineToFirstSubscription`,
          {
            planId,
            variantId,
            quantity,
          },
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    updateQuantity,
    removeProduct,
    addProduct,
  };
};
